import {PtrnIcons} from '../../patronTypes';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import InsertIcon from '@mui/icons-material/Save';
import UpdateIcon from '@mui/icons-material/Autorenew';
import CheckIcon from '@mui/icons-material/Check';
import UncheckIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/EditOutlined';
import PdfIcon from '@mui/icons-material/PictureAsPdf';
import ArticleIcon from '@mui/icons-material/Article';
import PtrnExcelIcon from './PtrnExcelIcon';
import WarningIcon from '@mui/icons-material/WarningAmber';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import SuccessIcon from '@mui/icons-material/CheckCircleOutline';
import AddIcon from '@mui/icons-material/Add';
import DiffIcon from '@mui/icons-material/Remove';
import ShowIcon from '@mui/icons-material/Visibility';
import FormulaLetraAIcon from './FormulaLetraAIcon';
import FormulaIcon from './FormulaIcon';
import Stop1Icon from '@mui/icons-material/DoDisturb';
import Stop2Icon from '@mui/icons-material/DoDisturbAlt';
import InfoIcon from '@mui/icons-material/Info';
import MicIcon from '@mui/icons-material/Mic';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

export default {
   [PtrnIcons.search]: SearchIcon,
   [PtrnIcons.delete]: DeleteIcon,
   [PtrnIcons.insert]: InsertIcon,
   [PtrnIcons.update]: UpdateIcon,
   [PtrnIcons.check]: CheckIcon,
   [PtrnIcons.uncheck]: UncheckIcon,
   [PtrnIcons.cancel]: CancelIcon,
   [PtrnIcons.edit]: EditIcon,
   [PtrnIcons.pdf]: PdfIcon,
   [PtrnIcons.txt]: ArticleIcon,
   [PtrnIcons.excel]: PtrnExcelIcon,
   [PtrnIcons.warning]: WarningIcon,
   [PtrnIcons.error]: ErrorIcon,
   [PtrnIcons.success]: SuccessIcon,
   [PtrnIcons.add]: AddIcon,
   [PtrnIcons.diff]: DiffIcon,
   [PtrnIcons.show]: ShowIcon,
   [PtrnIcons.formula]: FormulaIcon,
   [PtrnIcons.formulaLetraA]: FormulaLetraAIcon,
   [PtrnIcons.stop1]: Stop1Icon,
   [PtrnIcons.stop2]: Stop2Icon,
   [PtrnIcons.info]: InfoIcon,
   [PtrnIcons.mic]: MicIcon,
   [PtrnIcons.taskAltIcon]: TaskAltIcon
};
